module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-2.8d10775b.png";